import { getAttributionHost } from "@attribution/host";
import { readAttributionContext, writeAttributionContext } from "@attribution/storage";

/**
 * Stamps the funnel `sessionId` onto `lastTouch.sessionId` of the persisted
 * attribution context. Call once after the funnel session is created so the
 * handoff URL and downstream CAPI events carry the session identifier.
 *
 * When `lastTouch` does not yet exist (the user arrived without a recognized
 * click id, UTM, or platform detail — e.g. affiliate traffic with only
 * `?ref=`), a minimal `lastTouch` is synthesized so that the session
 * identifier is still carried through the handoff and into downstream CAPI
 * events. Without this, `onboardingFunnelCapiProvider.supports()` rejects
 * the event and the signup is never tracked in WAE.
 *
 * No-op when no attribution context has been captured yet (the funnel will
 * still function; only the stitching dimension is lost).
 */
export const stampSessionId = (sessionId: string): void => {
  const ctx = readAttributionContext();
  if (ctx === undefined) return;

  const { lastTouch } = ctx;

  if (lastTouch === undefined) {
    writeAttributionContext({
      ...ctx,
      lastTouch: {
        capturedAt: getAttributionHost().now(),
        network: "unknown",
        clickIds: {},
        sessionId,
      },
    });
    return;
  }

  if (lastTouch.sessionId === sessionId) return;

  writeAttributionContext({
    ...ctx,
    lastTouch: { ...lastTouch, sessionId },
  });
};
